import type { AiSourceRef } from "@l30/shared";

export type AskSourceChip = AiSourceRef & { title?: string; subtitle?: string };

export function isLockedAskSource(
  source: { type: string; id: string },
  locked: { type: string; id: string } | undefined,
): boolean {
  return locked != null && source.type === locked.type && source.id === locked.id;
}

/** Keep a locked primary first; never drop it when the user edits extra pins. */
export function withLockedPrimary(
  sources: AskSourceChip[],
  locked: AskSourceChip | undefined,
): AskSourceChip[] {
  if (!locked) return sources;
  const rest = sources.filter((source) => !isLockedAskSource(source, locked));
  const existing = sources.find((source) => isLockedAskSource(source, locked));
  return [
    { ...locked, ...existing, type: locked.type, id: locked.id, title: locked.title },
    ...rest,
  ];
}

export function withoutLockedPrimary(
  sources: AskSourceChip[],
  locked: { type: string; id: string } | undefined,
): AskSourceChip[] {
  if (!locked) return sources;
  return sources.filter((source) => !isLockedAskSource(source, locked));
}
